<!--
 * @Description:
 * @Author: YY
 * @LastEditors: YY
 * @LastEditTime: 2024-05-09 16:07:32
-->
<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="120px">
      <el-form-item label="返优惠调整单号" prop="code">
        <el-input v-model="form.code" placeholder="请输入返优惠调整单号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="调整类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in auditResultList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in auditStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="经营组织" prop="organization">
        <ajax-select
          v-model="form.organization"
          type="org"></ajax-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="addHandle" v-permission="'025010501'">新增</el-button>
        <el-button type="primary" @click="addHandle('manual')" v-permission="'025010505'">手动增加</el-button>
        <el-button type="primary" @click="exportHandle" v-permission="'025010503'">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="code"
        label="返利调整申请单号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="typeName"
        label="调整类型"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="totalAdjustAmount"
        label="金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="reason"
        label="原因"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="statusName"
        label="状态"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="申请人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="applyDate"
        label="审核时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="icCardNo"
        label="操作"
        width="150px"
        fixed="right">
        <template slot-scope="scope">
          <el-button @click="handleView(scope.row)" v-permission="'025010504'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <add-modal v-if="addModalVisible" :show.sync="addModalVisible" @onform="forms" :formData="addData" :showType="showType" :handleSearch="handleSearch" :isManual="isManual"/>
    <info-view-dialog v-if="viewDialogShow" :show.sync="viewDialogShow" :info="viewDialogInfo" @update:show="closeView"></info-view-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import addModal from './addModal'
import AjaxSelect from '../../../components/ajaxSelect/index'
import InfoViewDialog from './infoViewDialog'
export default {
  name: 'saleQuery',
  components: { AjaxSelect, addModal, InfoViewDialog },
  data () {
    return {
      form: {
      },
      tableData: [],
      addData: {},
      auditStatusList: [
        { value: '', label: '全部' },
        { value: 0, label: '待审核' },
        { value: 1, label: '已审核' },
        { value: 2, label: '审核未通过' }
      ],
      auditResultList: [
        { value: '', label: '全部' },
        { value: 0, label: '手动扣减' },
        { value: 1, label: '手动增加' },
        { value: 2, label: '失效解冻' }
      ],
      list: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      addModalVisible: false,
      showType: '',
      viewDialogShow: false,
      viewDialogInfo: {},
      isManual: false
    }
  },
  methods: {
    ...mapActions([
      'getAccountAdd',
      'rebateAdjustAccountPageDm',
      'rebateAdjustAccountExportDm'
    ]),
    handleOrgChange (e) {
      console.log(e)
    },
    onProtocolChange (e) {
      console.log(e)
    },
    // 搜索
    handleSearch () {
      this.addModalVisible = false
      const params = {
        ...this.form,
        orgId: this.form.organization,
        ...this.listState
      }
      this.rebateAdjustAccountPageDm(params).then(res => {
        const { list, total, pageNum, pageSize } = res
        this.tableData = list
        this.total = total
        this.listState.pageNo = pageNum
        this.listState.pageSize = pageSize
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    exportHandle () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          type: this.form.type,
          status: this.form.status,
          icCardNo: this.form.icCardNo,
          orgId: this.form.organization,
          processNo: this.form.processNo,
          code: this.form.code
        }
        this.rebateAdjustAccountExportDm(params).then(res => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '返利调整单.xls'
            // 兼容 IE系列 浏览器
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      })
    },
    handleView (item) {
      this.viewDialogShow = true
      this.viewDialogInfo = item
    },
    closeView () {
      this.viewDialogShow = false
    },
    addHandle (val) {
      if (val === 'manual') {
        this.isManual = true
      } else {
        this.isManual = false
      }
      this.addData = {}
      this.addModalVisible = true
      this.showType = 'add'
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.form.organization = ''
      this.form.code = ''
      this.form.processNo = ''
      this.form.icCardNo = ''
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
